import type { FaireProductEntity } from "../../entity_types/product";

export const p_9wjkqz3wuq: FaireProductEntity = {
  token: "p_9wjkqz3wuq",
  type: "product",
  name: "Block Party Scarf",
  brandToken: "b_qatwquj9mz",
  brandName: "Biquette",
  imageUrl:
    "https://cdn.faire.com/fastly/95161b719b71d9ac1f6141dda8810ff83a0a4a8a37f51dc9aa2513f2a704e1b3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6a4f13df8f8464a2746e0d805dbfcfd279a53b6edc91a83dd22ef586be63b09b.jpeg",
    "https://cdn.faire.com/fastly/e4669637c8c70f84e8433eb9f1972a2794bfaaba2b5213854917af166cb5a717.jpeg",
    "https://cdn.faire.com/fastly/3d348e53636b3e7cc24008d19ab6c030e8959747c47355aa0a5ac31a79b27ff6.jpeg",
    "https://cdn.faire.com/fastly/3a965d6a8b158cb787743d1a37cb75f3cd587470c0a4f77b823f0f1a5f6d147d.jpeg",
    "https://cdn.faire.com/fastly/55328ef50da6e0e2adcc779cf524464951fc545a41d24c4543064e2738299d35.jpeg",
  ],
  priceDollars: 37.5,
  description:
    "Block Party by artist Maddison Ball is a colorful checkered scarf that turns heads with its vibrant palette. The playful, graphic design adds an instant pop of personality to any outfit. Knit in soft Organic Cotton, premium long-staple Egyptian Cotton, or luxurious extra-fine Merino Wool depending on the colorway.\n",
  tags: [],
  msrpDollars: 75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:52.821Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
